export { default as EN } from "./en.json";
export const SHARED_NAMESPACE = "shared";